import React, { useEffect, useState } from "react";
import { Container, Grid, Input, Dropdown, Button, Icon, Search } from "semantic-ui-react";
import cx from "classnames";
import _ from "lodash";
import styles from "./transaction.module.scss";
import DatePicker from "react-datepicker";
import { LuRefreshCcw } from "react-icons/lu";
import { Checkbox } from "semantic-ui-react";
import TransactionRecords from "./records";


export default function Transactions({ account }) {
  const [searchText, setSearchText] = useState("");

  const [filters, setFilters] = useState({
    type: "ALL",
    status: "ALL",
    sort: "created_date",
    order: "DESC",
    query: ""
  })

  const statusOptions = [
    { key: "all", text: "All", value: "ALL" },
    { key: "completed", text: "Completed", value: "COMPLETED" },
    { key: "processing", text: "Processing", value: "PROCESSING" },
    { key: "error", text: "Error", value: "ERROR" },
  ];

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value
    }));
  };

  const onSearchChange = (e) => {
    let value = e.target.value;
    if (!value) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        ["query"]: searchText
      }));
    }

    setSearchText(value);
  };

  const onSearchClick = (e) => {
    e.preventDefault();
    setFilters((prevFilters) => ({
      ...prevFilters,
      ["query"]: searchText
    }));
  };

  const onSearchSubmit = (e) => {
    e.preventDefault();
    setFilters((prevFilters) => ({
      ...prevFilters,
      ["query"]: searchText
    }));
  };


  return (
    <Container className={cx(styles.container)}>
      <Grid>
        {/* Filters */}
        <Grid.Row columns={3} className={cx(styles.filterContainer)}>
          <Grid.Column>
            <Dropdown
              fluid
              selection
              placeholder="Select Status"
              options={statusOptions}
              value={filters.status}
              onChange={(e, { value }) => handleFilterChange("status", value)}
            />
          </Grid.Column>

          <Grid.Column >
            <label className={cx(styles.checkboxLabel)}>
              <Checkbox
                toggle
                label="Datasource"
                checked={filters.type === "DATASOURCE"}
                onChange={(e, data) =>
                  handleFilterChange("type", data.checked ? "DATASOURCE" : "ALL")
                }
              />
            </label>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <form onSubmit={onSearchSubmit} className={cx(styles.search)}>
              <Search
                id="search"
                input={{
                  icon: (
                    <Icon circular name="search" onClick={onSearchClick} />
                  ),
                  className: cx(styles.input),
                }}
                showNoResults={false}
                value={searchText}
                onSearchChange={onSearchChange}
                placeholder="Search by asset name or creator email"
              ></Search>
            </form>
          </Grid.Column>
        </Grid.Row>

      </Grid>

      <TransactionRecords account={account} filters={filters} setFilters={setFilters} />

    </Container>
  );
}